import styled from "styled-components";

const IconContainer = styled.div`
  color: #000;
  background: #fff;
  height: 60px;
  width: 50px;
  box-shadow: 0 0 0 3px rgb(0 0 0 / 10%);
  align-items: center;
  display: flex;

  @media (max-width: 767px) {
    height: 40px;
    width: 40px;
  }
  @media (max-width: 576px) {
    height: 30px;
    width: 30px;
  }
`;
export default IconContainer;
